import React from 'react'
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Generica from "../../personas/generica/Generica";
import AppBarModal from "../../general/AppBarModal";
import { BtnDetalle, BtnPermiso, BtnForm, BtnGestionar } from "../../general/BotonesAccion";
import ListarDatos from "../../general/ListarDatos";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from '../../../global/imagenes/emma_w.png';
import { consulta, rutaImg } from "../../../global/js/funciones";
import { ENTIDADES_FINANCIERAS, ESTADOS_FINANCIEROS, TIPOS_FINANCIEROS, PROGRAMAS } from "./../helper";

class CreditoPermisos extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      cargando: true,
      personas: [],
      generica: {
        tipo: 0,
        id: 0,
      },
      modal: false,
      id_persona: null,
    }
  }

  async componentDidMount() {
    let personas = await this.obtenerCreditos();
    this.setState({ personas, cargando: false })
  }


  acciones(data) {
    const onClickEntidad = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 6, id: ENTIDADES_FINANCIERAS } });
    const onClickEstado = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 7, id: ESTADOS_FINANCIEROS } });
    const onClickTipo = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 16, id: TIPOS_FINANCIEROS } });
    const onClickPrograma = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: 36, id: PROGRAMAS } });
    let entidad = <BtnDetalle callback={() => onClickEntidad(data)} texto='Entidades' color='#2196f3' />;
    let estados = <BtnPermiso callback={() => onClickEstado(data)} texto='Estados' />;
    let tipos = <BtnGestionar callback={() => onClickTipo(data)} texto='Tipos' />;
    let programas = <BtnDetalle callback={() => onClickPrograma(data)} texto='Programas(SOLO AUXILIARES ACAD.)' />;
    return <div>{tipos} {entidad} {estados} {programas}</div>
  }

  async obtenerCreditos() {
    return new Promise(resolve => {
      consulta(`api/v1.0/creditos/gestores`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  render() {
    let { modal, id_persona, generica, cargando, personas } = this.state;
    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;
    return (
      <div>
        <ListarDatos
          datos={personas}
          titulo='Lista Gestores'
          buscar={true}
          agregar={false}
          opciones={true}
          descargar='EMMA - GESTORES'
          id='tbl_coordinadores'
          acciones={row => this.acciones(row)}
          avatarImg={true}
          avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
          fila_principal={({ primer_nombre, primer_apellido, segundo_apellido }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}`}
          filas={[
            { 'id': 'correo' },
            { 'id': 'identificacion' },
          ]}
        />

        <Dialog open={modal} fullWidth={true} maxWidth='sm' onClose={() => this.setState({ modal: false })}>
          <AppBarModal titulo='¡ Lista Permisos !' mostrarModal={() => this.setState({ modal: false })} accion={() => this.setState({ modal: false })} titulo_accion='CERRAR' />
          <DialogContent style={{ padding: 0 }} className='scroll'>
            <Generica tipo={generica.tipo} persona={{ id: id_persona }} genericaRelacionId={generica.id} titulo="¡ Nuevo Permiso !" tituloInput="Permisos" tituloEliminar='¿ Eliminar Permiso ?' />
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={() => this.setState({ modal: false })} />
          </DialogActions>
        </Dialog>
      </div>
    );
  }

}

export default CreditoPermisos;


